<div *ngIf="isLoggedInUser" class="nav-menu mat-card" aria-labelledby="menu-items">
  <button disableRipple mat-button [matMenuTriggerFor]="shipment">
    {{ 'menuBar.shipment' | translate }}
  </button>
  <mat-menu #shipment="matMenu">
    <button mat-menu-item routerLink="/shipment-list">
      {{ 'menuBar.babyShipment' | translate }}
    </button>
    <button mat-menu-item routerLink="/maw-list">
      {{ 'menuBar.motherBBX' | translate }}
      <ng-container *ngIf="!loosBbxConfig"> {{ 'menuBar.linking' | translate }}</ng-container>
    </button>
  </mat-menu>

  <button disableRipple mat-button [matMenuTriggerFor]="Configuration">
    {{ 'menuBar.configuration' | translate }}
  </button>
  <mat-menu #Configuration="matMenu">
    <button mat-menu-item (click)="navigationToOnboarding()">
      {{ 'menuBar.customerOnboarding' | translate }}
    </button>
    <button mat-menu-item (click)="navigationToMapping()">
      {{ 'menuBar.specification' | translate }}
    </button>
  </mat-menu>

  <button disableRipple mat-button (click)="navigationTosearchAdress()">
    {{ 'menuBar.address' | translate }}
  </button>

  <button disableRipple mat-button (click)="navToPickupList()">
    {{ 'menuBar.pickup' | translate }}
  </button>

  <button disableRipple mat-button (click)="navTocreateReports()">
    {{ 'menuBar.report' | translate }}
  </button>
</div>
